import listActions from 'src/modules/firma/list/firmaListActions';
import FirmaService from 'src/modules/firma/firmaService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'FIRMA_DESTROY';

const firmaDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: firmaDestroyActions.DESTROY_STARTED,
      });

      await FirmaService.destroyAll([id]);

      dispatch({
        type: firmaDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.firma.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/firma');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: firmaDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: firmaDestroyActions.DESTROY_ALL_STARTED,
      });

      await FirmaService.destroyAll(ids);

      dispatch({
        type: firmaDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.firma.destroyAll.success'),
      );

      getHistory().push('/firma');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: firmaDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default firmaDestroyActions;
